<template>
    <div class="game page">
        <ui :wrong="wrong" :time="time" :progress="progress" :correct="correct"></ui>

        <div class="cards">
            <div class="next-card"></div>
            <div class="card current">
                <span class="upper-word">{{ upper_word }}</span>
                <span class="lower-word">{{ lower_word }}</span>
            </div>
        </div>

        <button-stage></button-stage>
    </div>
</template>

<script>
import ButtonStage from '@/components/ButtonStage.vue';
import Ui from '@/components/Ui.vue';
import EventBus from '@/EventBus.js';
import router from '../router'

export default {
    name: 'game',
    components: {
        ButtonStage,
        Ui
    },
    data() {
        return {
            wrong: 0,
            correct: 0,
            time: 90,
            maxtime: 90,
            progress: 100,
            tickerId: 0,
            upper_word: '',
            lower_word: '',
            levenshtein_distance: 0
        }
    },
    methods: {
        startTimer() {
            this.wrong = 0;
            this.correct = 0;
            this.tickerId = window.setInterval(this.tickDown, 1000);
        },
        tickDown() {
            this.time--;
            this.progress = this.time / this.maxtime * 100;

            if (this.time == 0) {               
                EventBus.dispatch('game-end');
            }
        },
        getRandomWords() {
            let len = window.config.words.length;
            let first_word = window.config.words[Math.floor(Math.random() * len)];
            let first_word_length = first_word.length;
            let second_word = '';

            let i = 0;
            while (second_word == first_word || window.levenshtein(first_word, second_word) >= first_word_length) {
                second_word = window.config.words[Math.floor(Math.random() * len)];
                i++;
                if (i > 100) {
                    break;
                }
            }

            this.upper_word = first_word;
            this.lower_word = second_word;
            this.levenshtein_distance = window.levenshtein(this.upper_word, this.lower_word);
            EventBus.dispatch('new-levenshtein-distance', this.levenshtein_distance);
        },
        handleCorrect() {
            this.correct++;
            window.setTimeout(this.startNextRound, 600);
        },
        handleWrong() {
            this.wrong++;
            window.setTimeout(this.startNextRound, 600);
        },
        startNextRound() {
            this.getRandomWords();
        },
        goToOutro() {
            window.APP.score = 0;
            // Calculate the Score
            window.APP.score = (this.correct * 10) - (this.wrong * this.wrong);
            router.replace('outro');
        },
        handleGameEnd() {
            window.clearInterval(this.tickerId);
            // Give everyone time for outro...?
            window.setTimeout(this.goToOutro, 800);
        }
    },
    mounted() {
        window.APP.score = 0;
        // Hook into Events
        EventBus.on('on-correct-choice', this.handleCorrect);
        EventBus.on('on-wrong-choice', this.handleWrong);
        EventBus.on('game-end', this.handleGameEnd);

        // Dispatch Game Start (start timer)
        this.startTimer();
        // Dispatch Round Start (intro cards and buttons)
        this.getRandomWords();
    }
}
</script>

<style lang="scss">
.game {
    height: calc(100vh - 20px);
    max-height: 600px;
    margin: 20px 0 0;
    display: flex;
    flex-flow:column;
    flex-wrap:nowrap;
    justify-content: space-between;
}
.cards {
    position: relative;
}
.card {
    width:90%;
    margin:0 auto;
    padding: 40px 0;
    background:url("../assets/hr.png") center center no-repeat #FFF;
    border-radius: 12px 12px;
    box-shadow: 10px 0 25px rgba(0,0,0,0.1);
    position: relative; 
    z-index: 100;

    img {
        display:block;
        margin: 10px auto;
    }
    span {
        font-family: 'VarelaRound';
        font-size: 48px;
        display:block;
        text-align: center;
        &:first-of-type {
            margin-bottom: 30px;
        }
    }
}

.next-card {
    background-color: #FFF;
    border-radius: 12px 12px;
    box-shadow: 10px 0 25px rgba(0,0,0,0.1);
    position: absolute;
    display: block;
    z-index:0;
    width: 80%;
    content: " ";
    bottom: -10px;
    height: 50px;
    left: 50%;
    transform:translateX(-50%);
}


</style>
